import { useRef } from "react";
import classNames from "classnames";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    isOverflowingX,
    useTruncationTooltip,
} from "@design-system/Tooltip/useTruncationTooltip";
import styles from "../CoaMappingDrawer.module.scss";

interface CoaMappingEllipsisTextProps {
    text: string;
    className?: string;
}

export const CoaMappingEllipsisText = ({
    text,
    className,
}: CoaMappingEllipsisTextProps) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const truncationTooltipProps = useTruncationTooltip({
        ref: textRef,
        isTruncated: isOverflowingX,
    });

    return (
        <Tooltip content={text} {...truncationTooltipProps}>
            <span
                ref={textRef}
                className={classNames(styles.ellipsisText, className)}
            >
                {text}
            </span>
        </Tooltip>
    );
};
